import { ref, computed } from 'vue';

interface UsePaginationOptions {
  initialPage?: number;
  pageSize?: number;
}

export function usePagination(options: UsePaginationOptions = {}) {
  const { initialPage = 1, pageSize = 10 } = options;

  const currentPage = ref(initialPage);
  const totalItems = ref(0);

  const totalPages = computed(() => Math.ceil(totalItems.value / pageSize));

  function setTotal(total: number) {
    totalItems.value = total;
  }

  function reset() {
    currentPage.value = initialPage;
  }

  function nextPage() {
    if (currentPage.value < totalPages.value) {
      currentPage.value++;
    }
  }

  function previousPage() {
    if (currentPage.value > 1) {
      currentPage.value--;
    }
  }

  function goToPage(page: number) {
    if (page >= 1 && page <= totalPages.value) {
      currentPage.value = page;
    }
  }

  return {
    currentPage,
    pageSize,
    totalPages,
    totalItems,
    setTotal,
    reset,
    nextPage,
    previousPage,
    goToPage,
  };
}
